/* ==========================================================================
   toca.nfc — scripts propios (prefijo tn-). Vainilla, sin librerías.
   Un único archivo, cargado una vez con defer desde layout/theme.liquid.
   ========================================================================== */
(function () {
  if (window.__tnLoaded) return;
  window.__tnLoaded = true;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Reveal on scroll (compartido por toda la tienda) ---------------- */
  function initReveal() {
    var items = document.querySelectorAll('.tn-reveal');
    if (!items.length) return;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('tn-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tn-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { obs.observe(el); });
  }

  /* ---------------- Contadores (sección cifra) ---------------- */
  function initContadores() {
    var nums = document.querySelectorAll('[data-tn-count]');
    if (!nums.length) return;
    var done = new WeakSet();
    function run(el) {
      if (done.has(el)) return;
      done.add(el);
      var target = parseInt(el.getAttribute('data-tn-count'), 10) || 0;
      if (prefersReducedMotion) { el.textContent = target; return; }
      var start = 0;
      var duration = 1200;
      var startTime = null;
      function step(ts) {
        if (startTime === null) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(start + (target - start) * eased);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target;
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { obs.observe(el); });
  }

  /* ---------------- FAQ acordeón ---------------- */
  function initFaq() {
    var groups = document.querySelectorAll('[data-tn-faq]');
    groups.forEach(function (group) {
      var items = group.querySelectorAll('.tn-faq-item');
      items.forEach(function (item) {
        var btn = item.querySelector('.tn-faq-q');
        var ans = item.querySelector('.tn-faq-a');
        if (!btn || !ans) return;
        btn.addEventListener('click', function () {
          var wasOpen = item.classList.contains('tn-open');
          items.forEach(function (i) {
            i.classList.remove('tn-open');
            var a = i.querySelector('.tn-faq-a');
            if (a) a.style.maxHeight = 0;
          });
          if (!wasOpen) {
            item.classList.add('tn-open');
            ans.style.maxHeight = ans.scrollHeight + 'px';
          }
        });
      });
    });
  }

  /* ---------------- Tilt sutil en tarjetas (solo puntero fino) ---------------- */
  function initTilt() {
    if (prefersReducedMotion) return;
    if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;
    var cards = document.querySelectorAll('.tn-card, .tn-price-card');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 4) + 'deg) rotateX(' + (y * -4) + 'deg)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------------- Galería de producto ---------------- */
  function initGaleria() {
    var galleries = document.querySelectorAll('[data-tn-gallery]');
    galleries.forEach(function (gal) {
      var main = gal.querySelector('[data-tn-gallery-main] img');
      var thumbs = gal.querySelectorAll('[data-tn-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-tn-full');
          var alt = thumb.getAttribute('data-tn-alt') || '';
          if (!full) return;
          main.setAttribute('src', full);
          main.setAttribute('alt', alt);
          thumbs.forEach(function (t) { t.classList.remove('tn-active'); });
          thumb.classList.add('tn-active');
        });
      });
    });
  }

  /* ---------------- Selector de variantes + cantidad ---------------- */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = cents / 100;

    function grouped(v, decimals, thousands, decimalSep) {
      var fixed = v.toFixed(decimals);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? intPart + decimalSep + parts[1] : intPart;
    }

    if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      return format.replace('{{amount_no_decimals_with_comma_separator}}', grouped(value, 0, '.', ','));
    }
    if (format.indexOf('amount_with_comma_separator') !== -1) {
      return format.replace('{{amount_with_comma_separator}}', grouped(value, 2, '.', ','));
    }
    if (format.indexOf('amount_with_apostrophe_separator') !== -1) {
      return format.replace('{{amount_with_apostrophe_separator}}', grouped(value, 2, "'", '.'));
    }
    if (format.indexOf('amount_no_decimals') !== -1) {
      return format.replace('{{amount_no_decimals}}', grouped(value, 0, ',', '.'));
    }
    return format.replace('{{amount}}', grouped(value, 2, ',', '.'));
  }

  function initProductoForm() {
    var root = document.querySelector('[data-tn-product-form]');
    if (!root) return;

    var dataEl = root.querySelector('[data-tn-variants-json]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var moneyFormat = root.getAttribute('data-tn-money-format') || '${{amount}}';
    var idInput = root.querySelector('[data-tn-variant-id]');
    var priceNow = root.querySelector('[data-tn-price-now]');
    var priceCompare = root.querySelector('[data-tn-price-compare]');
    var addBtn = root.querySelector('[data-tn-add-btn]');
    var stockMsg = root.querySelector('[data-tn-stock-msg]');
    var qtyInput = root.querySelector('[data-tn-qty-input]');
    var optionGroups = root.querySelectorAll('[data-tn-option-group]');

    var selected = {};
    optionGroups.forEach(function (group) {
      var name = group.getAttribute('data-tn-option-group');
      var activeBtn = group.querySelector('.tn-active');
      selected[name] = activeBtn ? activeBtn.getAttribute('data-tn-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (name) {
          return v.options[name] === selected[name];
        });
      });
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      priceNow.textContent = formatMoney(variant.price, moneyFormat);
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        priceCompare.textContent = formatMoney(variant.compareAtPrice, moneyFormat);
        priceCompare.style.display = '';
      } else {
        priceCompare.style.display = 'none';
      }
      var available = variant.available;
      addBtn.disabled = !available;
      addBtn.textContent = available ? addBtn.getAttribute('data-tn-label-add') : addBtn.getAttribute('data-tn-label-sold-out');
      if (stockMsg) {
        stockMsg.textContent = available ? (stockMsg.getAttribute('data-tn-in-stock') || '') : (stockMsg.getAttribute('data-tn-out-stock') || '');
        stockMsg.className = 'tn-stock-msg ' + (available ? 'tn-stock-msg--ok' : 'tn-stock-msg--out');
      }

      optionGroups.forEach(function (group) {
        var name = group.getAttribute('data-tn-option-group');
        var buttons = group.querySelectorAll('[data-tn-value]');
        buttons.forEach(function (b) {
          var value = b.getAttribute('data-tn-value');
          var testSel = Object.assign({}, selected);
          testSel[name] = value;
          var match = variants.find(function (v) {
            return Object.keys(testSel).every(function (n) { return v.options[n] === testSel[n]; });
          });
          b.disabled = !match || !match.available;
        });
      });
    }

    optionGroups.forEach(function (group) {
      var name = group.getAttribute('data-tn-option-group');
      var buttons = group.querySelectorAll('[data-tn-value]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          buttons.forEach(function (b) { b.classList.remove('tn-active'); });
          btn.classList.add('tn-active');
          selected[name] = btn.getAttribute('data-tn-value');
          render();
        });
      });
    });

    if (qtyInput) {
      root.querySelectorAll('[data-tn-qty-step]').forEach(function (stepBtn) {
        stepBtn.addEventListener('click', function () {
          var dir = parseInt(stepBtn.getAttribute('data-tn-qty-step'), 10);
          var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + dir);
          qtyInput.value = next;
        });
      });
    }

    if (variants.length) render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initFaq();
    initTilt();
    initGaleria();
    initProductoForm();
  });
})();
